import { render } from "./TenantSelector.vue?vue&type=template&id=12debb41&scoped=true"
import script from "./TenantSelector.vue?vue&type=script&lang=js"
export * from "./TenantSelector.vue?vue&type=script&lang=js"

import "./TenantSelector.vue?vue&type=style&index=0&id=12debb41&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12debb41"]])

export default __exports__